.wrap {
  position: relative;
  top: -2px;
}

.button {
  margin: -36px 0 12px 86px;
  padding-bottom: 2px;
  width: 25px;
  font-size: 20px;
  cursor: pointer;
  
  &:hover {
    opacity: .5;
  }
}

.popup {
  display: flex;
  position: absolute;
  padding: 20px;
  z-index: 5;
  background: white;
  width: 372px;
  left: 12px;
  box-shadow: 0px 0px 5px rgba(0,0,0,.5);
  border-radius: 3px;
}

.input {
  width: 100%;
  font-size: 14px;
  outline: none;
  padding: 6px 4px 3px;
}

.cancelButton {
  font-family: sans-serif;
  position: relative;
  top: 8px;
  margin-left: 13px;
  cursor: pointer;
  
  &:hover {
    opacity: .5;
  }
}

.artistList {
  margin-top: 4px;
  margin-left: 115px;
  line-height: 1.8;
  cursor: default;
  padding: 6px 4px 8px;
  
  .isNewArtist {
    color: green;
  }
}

// .wrap trix-toolbar {
//   display: none;
// }
// .wrap trix-editor {
//   width: 100%;
//   border: none;
//   border-radius: 0;
//   padding: 6px 4px 3px;
//   min-height: 0;
//   line-height: 1.3;
//   outline: none;

//   &:not(.active):hover {
//     background: #e8e8e8;
//     cursor: pointer;
//   }
// }
